import React, {useEffect, useState} from "react";
import "./OnlineProduct.scss";
import {OnlineSearch} from "../../Components";
import {useHistory, useLocation, useParams} from "react-router-dom";
import {StoreOnlineLike, StoreOnlineProduct} from "./onlineProductService";
import {useBasket, useDispatchBasket, useResp} from "../../hooks";
import {AddBasket, RemoveBasket} from "../../Components/OnlineAddress/OnlineAddressService";
import Expand from 'react-expand-animated';
import {RecommendRegal} from "../../Components/RecommendRegal/RecommendRegal";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import ProductResponsive from "../ProductResponsive/ProductResponsive";
import {openNotificationWithIcon} from "../../Services";

function numberWithCommas  (x) {
    if (x === 0) {
        return 0
    }
    if(x){
        x= Math.round(x)
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }

    return "-"

}

function AttrMobileSec({sec}){
    return(
        <div className="description-section-mobile-item">
            {sec.map(m=>{
                switch(m.type){
                    case 'h2':
                        return(
                            <div className="description-section-item-title">
                                <span>{m.text}</span>
                            </div>
                        )
                        break;
                    case 'p':
                        return(
                            <div className="description-section-item-desc">
                                <p>{m.text}</p>
                            </div>
                        )
                        break;
                    case 'li':
                        return(
                            <div className="description-section-item-li">
                                <li>{m.text}</li>
                            </div>
                        )
                        break;
                }
            })}
        </div>
    )
}


function AddToBasket({item}) {

    //hooks
    const setBasket = useDispatchBasket();
    const basket = useBasket();

    const history = useHistory();


    //states
    const [loading,set_loading] = useState(false)

    // useEffect(()=>{
    //     console.log("locat" ,location)
    // },[])

    const addToBasket = async (pId) =>{
        let merchantId = window.location.pathname.split("/")[2]
        const response = await AddBasket(merchantId,pId,item)
        // console.log("Add : ",response)
    }

    const removeFromBasket = async (pId) =>{
        let merchantId = window.location.pathname.split("/")[2]
        const response = await RemoveBasket(merchantId,pId)
        // console.log("Remove : ",response)
    }

    //functions
    const inc = async () =>{
        if(loading){return }
        try{
            set_loading(true)
            //ADD API
            await addToBasket(item.uid);
            let merchantId = window.location.pathname.split("/")[2]
            openNotificationWithIcon('success',item,history,merchantId)
            set_loading(false)
        }catch (e) {
            set_loading(false)
            return ;
        }
        //--------------------------------- Context Change ----------------------------------------------
        //check exist in basket
        if(basket.find(product=>product.product.uid===item.uid)){
            //exist
            let filter = basket.map(pro => pro.product.uid === item.uid ? {...pro, count : pro.count+1} : pro)
            //context change
            setBasket(filter);
            //storage change
            localStorage.setItem("basket",JSON.stringify(filter));
        }else {
            //not exist

            //context change
            setBasket(oldArray => [...oldArray, {product:item,count:1}]);
            //storage change
            localStorage.setItem("basket",JSON.stringify([...basket, {product:item,count:1}]));
        }

    }

    const dec = async () =>{
        if(loading){return }
        try{
            set_loading(true)
            //Remove API
            await removeFromBasket(item.uid)
            set_loading(false)
        }catch (e) {
            set_loading(false)
            return ;
        }
        //--------------------------------- Context Change ----------------------------------------------
        //check exist in basket
        let find = basket.find(product=>product.product.uid===item.uid);
        if(find){
            //exist
            if(find.count>0){
                //exist
                let filter = basket.map(pro => pro.product.uid === item.uid ? {...pro, count : pro.count-1} : pro)

                if(find.count===1){
                    //context change
                    setBasket(basket.filter(product=>product.product.uid!==item.uid))
                    //storage change
                    localStorage.setItem("basket",JSON.stringify(basket.filter(product=>product.product.uid!==item.uid)));
                }else {
                    //context change
                    setBasket(filter);
                    //storage change
                    localStorage.setItem("basket",JSON.stringify(filter));
                }
            }else {
                //context change
                setBasket(basket.filter(product=>product.product.uid!==item.uid))
                //storage change
                localStorage.setItem("basket",JSON.stringify(basket.filter(product=>product.product.uid!==item.uid)));
            }
        }
    }

    const remove = () =>{
        //--------------------------------- Context Change ----------------------------------------------
        setBasket(basket.filter(product=>product.product.uid!==item.uid))
        //--------------------------------- Local Storage Change ----------------------------------------------
        setTimeout(()=>{
            localStorage.setItem("basket",JSON.stringify(basket));
        },500)
    }

    const checkCount = () => {
        let basket_count = basket.find(product=>product.product.uid===item.uid);
        if(basket_count){
            return basket_count.count;
        }
        return 0;
    }


    return(
        <div className="add-remove-section-footer">
            {checkCount()<1?<span className="add-btn-text"  onClick={inc}>اضافه کردن به سبد خرید</span>:
                <div className="active-footer-sec">
                    <div className="price-footer-sec">
                        <div className="percent-off-footer-cont">
                            {item && item.discount_percentage!==0?
                                <span className="percent-off-footer">%{item.discount_percentage}</span>:
                                null
                            }

                            <span style={{textDecoration:"line-through"}}>{numberWithCommas(checkCount()*item.price_original)}</span>
                        </div>
                        <div style={{direction:"rtl"}}><span>{numberWithCommas(checkCount()*item.price)} ریال </span></div>
                    </div>
                <div className="calc">
                    {/*{item.stock>checkCount()?<i className="fa fa-plus" onClick={inc}></i>:null}*/}
                    {checkCount()>0?<>
                        <i className="fa fa-minus" onClick={dec}></i>
                        <span style={{direction:"rtl",padding:"0 16px"}} className="product-count-number">
                            {!loading?checkCount():<i className="fa fa-spinner fa-spin"></i>}
                        </span>
                    </>:null}
                    <i className="fa fa-plus" onClick={inc}></i>
                </div>
                </div>
            }
        </div>
    )
}


function OnlineProduct() {

    const location = useLocation();
    const resp = useResp()

    //states
    const [addMode ,set_addMode] = useState(false);
    const [likeMode ,set_likeMode] = useState(false);
    const [product ,set_product] = useState(false);
    const [isLogin, set_isLogin] = useState(false);


    const [attribExpand ,set_attribExpand] = useState(false);
    const [descExpand ,set_descExpand] = useState(true);

    //hooks
    const history = useHistory();
    const { merchantId,productId } = useParams();

    useEffect(()=>{
        window.scrollTo({left: 0, top: 0});
        getProduct();
        if(localStorage.getItem('token')){
            set_isLogin(true)
        }
    },[location])



    //functions
    const getProduct = async () =>{
        try{
            const response = await StoreOnlineProduct(merchantId,productId);
            // console.log("TRE ",response);
            set_product(response.data)
        }catch (e) {
            // console.log(e)
        }
    }

    const like = async ()=>{
        try{
            const response = await StoreOnlineLike(merchantId,productId);
            // console.log("TRE ",response);
            getProduct()
        }catch (e) {
            // console.log(e)
        }
    }

    function numberWithCommas  (x) {
        if (x === 0) {
            return 0
        }
        if(x){
            x= Math.round(x)
            return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
        }

        return "-"

    }

    const { height, width,mobileWidth } = useWindowDimensions();



    return(
        <>
            {resp?<div className="home-container-res">
                <ProductResponsive merchant={merchantId} product={product}/>
            </div>:null}
            {!resp ?
                <div className="online-product-container">
                    {isLogin?<OnlineSearch direct={location.state && location.state.direct?true:false} merchantId={merchantId}/>:null}
                    <div className="online-product-item" style={!isLogin?{margin:8}:null}>
                        {isLogin?<div className="like-sectoin" onClick={()=>{
                            like()
                        }}>
                            {product && product.is_liked?
                                <i className="fa fa-heart"></i>:
                                <i className="fa fa-heart-o"></i>
                            }
                        </div>:null}

                        <div className="img-section">
                            <img src={product.image} alt=""/>
                        </div>

                        <div className="info-section">
                            <span>{product.name}</span>
                            <div className="price-section">
                                {product?.price_original!==product?.price?
                                    <span style={{direction:"rtl"}} className="original-price">{numberWithCommas(product.price_original)} </span>:null
                                }

                                <span style={{direction:"rtl"}} className="price">{numberWithCommas(product.price)} ریال </span>
                            </div>
                        </div>
                    </div>

                    <div className="online-product-attr">
                        {/*<div className="online-product-attr-item">*/}
                        {/*    <div className="online-product-attr-item-label"  onClick={()=>{*/}
                        {/*        set_attribExpand(!attribExpand)*/}
                        {/*    }}>*/}

                        {/*        <i className={attribExpand?"fa fa-angle-down":"fa fa-angle-left"}></i>*/}
                        {/*        <span>ویژگی محصولات</span>*/}
                        {/*    </div>*/}
                        {/*    <Expand open={attribExpand}>*/}
                        {/*        <div className="product-atrrib-row">*/}
                        {/*            <div className="attr-value">{product && product.weight?product.weight:" - "}</div>*/}
                        {/*            <div className="attr-label">وزن : </div>*/}
                        {/*        </div>*/}
                        {/*        <div className="product-atrrib-row">*/}
                        {/*            <div className="attr-value">{product && product.brand ? product.brand.name : " - "}</div>*/}
                        {/*            <div className="attr-label">برند : </div>*/}
                        {/*        </div>*/}
                        {/*        /!*<div className="product-atrrib-row">*!/*/}
                        {/*        /!*    <div className="attr-value">{product && product.parent.name}</div>*!/*/}
                        {/*        /!*    <div className="attr-label">نوع : </div>*!/*/}
                        {/*        /!*</div>*!/*/}
                        {/*    </Expand>*/}
                        {/*</div>*/}


                        <div className="online-product-attr-item">
                            <div className="online-product-attr-item-label"  onClick={()=>{
                                set_descExpand(!descExpand)
                            }}>
                                <i className={descExpand?"fa fa-angle-down":"fa fa-angle-left"}></i>
                                <span>توضیحات </span>
                            </div>
                            <Expand open={descExpand}>
                                <p>
                                    {product.des}
                                </p>
                                {product?.extra_info?.texts?.map(t=>{
                                    return(
                                        <AttrMobileSec sec={t}/>
                                    )
                                })}

                            </Expand>
                        </div>
                        {product.uid?<RecommendRegal item={product}/>:null}
                    </div>

                    <div className="online-product-footer" style={{width:mobileWidth?mobileWidth:document?.getElementById('mobile-sec')?.clientWidth,zIndex:2}}>
                        <div className="notAdded-mode">
                            {/*<div className="add-to-basket-btn">*/}
                            {/*    <span>افزودن به سبد خرید</span>*/}
                            {/*</div>*/}
                            {product?<AddToBasket item={product}/>:null}
                        </div>
                        {/*<div className="added-mode">*/}
                        {/*    <span>به سبد خرید افزوده شد</span>*/}
                        {/*    <select name="" id="">*/}
                        {/*        <option value="">1</option>*/}
                        {/*        <option value="">2</option>*/}
                        {/*        <option value="">3</option>*/}
                        {/*    </select>*/}
                        {/*</div>*/}
                    </div>

                    {/*{!isLogin?*/}
                    {/*    <div className="online-store-auth-btn" style={{position:'fixed',width:'100%',bottom:10}}>*/}
                    {/*        <div className="online-store-sec land-btn" style={{padding:0,margin:"20px 32px"}} onClick={()=>{*/}
                    {/*            console.log("sdadad",product)*/}
                    {/*            if(product && product.merchant.mall){*/}
                    {/*                history.push("/login",*/}
                    {/*                    {mall:product.merchant.mall,*/}
                    {/*                        from:{pathname:`/online-store-product/${product.merchant.uid}/${product.uid}`}*/}
                    {/*                    }*/}
                    {/*                )*/}
                    {/*            }*/}
                    {/*        }}>*/}
                    {/*            <div className="online-store-btn">*/}
                    {/*                <span> ورود/عضویت  در باشگاه مشتریان </span>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*    :*/}
                    {/*    <div className="online-product-footer" style={{width:mobileWidth?mobileWidth:document?.getElementById('mobile-sec')?.clientWidth,zIndex:2}}>*/}
                    {/*        <div className="notAdded-mode">*/}
                    {/*            /!*<div className="add-to-basket-btn">*!/*/}
                    {/*            /!*    <span>افزودن به سبد خرید</span>*!/*/}
                    {/*            /!*</div>*!/*/}
                    {/*            {product?<AddToBasket item={product}/>:null}*/}
                    {/*        </div>*/}
                    {/*        /!*<div className="added-mode">*!/*/}
                    {/*        /!*    <span>به سبد خرید افزوده شد</span>*!/*/}
                    {/*        /!*    <select name="" id="">*!/*/}
                    {/*        /!*        <option value="">1</option>*!/*/}
                    {/*        /!*        <option value="">2</option>*!/*/}
                    {/*        /!*        <option value="">3</option>*!/*/}
                    {/*        /!*    </select>*!/*/}
                    {/*        /!*</div>*!/*/}
                    {/*    </div>*/}
                    {/*}*/}

                </div>:null
            }
            </>

    )

}

export {OnlineProduct}
